import { TopLevelSpec as VegaLiteSpec } from 'vega-lite';
import { liteBaseConfig } from '../vegaShared';

export interface IHBarOptions {
  data: any[];
  yField: string;
  colorField: string;
  stack?: boolean | 'center' | 'zero' | 'normalize' | null | undefined;
  xAxisTitle?: string;
  yAxisTitle?: string;
  xLabels?: boolean;
  yLabels?: boolean;
  width?: number | 'container';
  height?: number | 'container';
}

export const genHBarSpec = (options: IHBarOptions): VegaLiteSpec => {
  const config = {
    ...liteBaseConfig(),
    view: { fill: '#F9FAFF', stroke: 'white' },
  };
  const baseSpec: VegaLiteSpec = {
    $schema: 'https://vega.github.io/schema/vega-lite/v4.json',
    autosize: 'fit',
    width: options.width || 'container',
    height: options.height || undefined, // autoheight based on number of rows if height not specified
    mark: { type: 'bar', tooltip: true, stroke: 'white', strokeWidth: 2, cornerRadius: 2 },
    config,
    transform: [
      {
        calculate: `if(datum.${options.colorField}, 0, if(!datum.${options.colorField}, 1, 2))`,
        as: 'colorOrder',
      },
    ],
    encoding: {
      x: {
        aggregate: 'count',
        stack: options.stack || null,
        axis: {
          title: options.xAxisTitle || null,
          titlePadding: 20,
          format: options.stack ? '.0%' : undefined,
        },
      },
      y: {
        field: options.yField,
        type: 'nominal',
        sort: 'descending',
        axis: {
          title: options.yAxisTitle || null,
          titlePadding: 20,
          labelFontWeight: 700,
          labelFontSize: 11,
        },
      },
      color: {
        field: options.colorField,
        scale: { domain: [true, false], range: ['#3c5ccf', '#BAC5EE'] },
        legend: null,
      },
      order: {
        field: 'colorOrder',
      },
    },
    data: { values: options.data },
  };
  return baseSpec;
};
